export class TimeOffReportDto {
  type: string;
  days: number;
}
